module.exports = __webpack_public_path__ + "media/product/ctg-6-929ef871.png";